import React from 'react';
import { Link } from 'react-router-dom';
import RidesumLogo from '../../../components/ridesum-logo';
import UrlTo from '../../../url-to';
import './styles.scss';

const HeaderLogo = () => {
  return (
    <Link className="courses-header-logo" to={UrlTo.coursesHome()}>
      <RidesumLogo />
    </Link>
  );
};

export default HeaderLogo;
